<template>
		<div>
			<div class="actDiv">
				<label>小区</label>
				<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="请选择小区" label-in-value
							    option-filter-prop="children"  :filter-option="filterOption" show-search >
					<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
				<label>日期</label>
				 <a-range-picker @change="onDateChange"  style="margin: 0 0.625rem;font-size: 0.6875rem;"/>
				 <a-button   icon="bar-chart" @click="queryData" :loading="loading">查询</a-button>
			</div>
			<a-table size="small" :columns="columns" :data-source="dataList"  bordered  rowKey="MDLID"  :loading="loading"
							:pagination="false"  :scroll="{y:500}">
				<template slot="footer" slot-scope="currentPageData">
				      <div style="display: flex;flex-direction: row;justify-content: flex-end;">
						  <div  v-show="dataList.length>0" style="width:120px;display: flex;flex-direction: row;font-size: 0.75rem;">
							  合计：{{theTotal}}
						  </div>
					  </div>
				</template>			
			</a-table>
		</div>
</template>

<script>
	export default{
		data(){
			const  columns = [
				{
					title: '用户号',
					dataIndex: 'customerNum',
					width:85,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户名',
					dataIndex: 'CustomerName',
					width:80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '集中器地址',
					dataIndex: 'GPRSAddr',
					width:125,
					className:'v-cell',
					align:'center',
				},
				{
					title: '表地址',
					dataIndex: 'MeterAddr',
					width:125,
					className:'v-cell',
					align:'center',
				},
				{
					title: '钢印号',
					dataIndex: 'SteelNum',
					width:75,
					className:'v-cell',
					align:'center',
				},
				{
					title: '铅封号',
					dataIndex: 'qfh',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'useCount',
					width:75,
					className:'v-cell',
					align:'center',
				},
			];
			return {
				columns,
				theNeighbor:undefined,
				neighborList:[],
				dataList:[],
				beginDate:null,
				endDate:null,
				loading:false,
				theTotal:null,
			}
		},
		methods:{
			queryData:function(){
				if(this.theNeighbor == undefined){
					this.$message.error('请选择小区');
					return 
				}
				if(this.beginDate == null){
					this.$message.error('请选择日期');
					return 
				}
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_LARGE_METER_USE_COUNT_URL);
				let param = {neighborId:this.theNeighbor.key,beginDate:this.beginDate,endDate:this.endDate};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result.list;
						this.theTotal = result.summary;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
				
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.STATIS_LARGE_METER_NEIGHBORS_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onDateChange:function(date, dateString){
				 this.beginDate = dateString[0];
				 this.endDate = dateString[1];
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
		},
		created(){
			this.queryNeighbors();
		},
		
	}
</script>

<style>
</style>
